import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { EmrLinkState } from '../storeTypes';
import { resetAction } from '../actions/resetAction';
import { EmrLinkDto } from '../../types/backendType';

const initialState: EmrLinkState = {
  // Keyed by Percix user id. Value is the list of links for that patient
  // (one per adapter; v1 has only WebPT so this is usually 0 or 1 entries).
  links: {},
};

const emrLinkSlice = createSlice({
  name: 'emrLinkSlice',
  initialState,
  extraReducers: (builder) => builder.addCase(resetAction, () => initialState),
  reducers: {
    setEmrLinksAction: (
      draftState: EmrLinkState,
      action: PayloadAction<{ patientUserId: string; links: EmrLinkDto[] }>,
    ) => {
      const { patientUserId, links } = action.payload;
      draftState.links[patientUserId] = links;
    },
    upsertEmrLinkAction: (
      draftState: EmrLinkState,
      action: PayloadAction<{ link: EmrLinkDto }>,
    ) => {
      const { link } = action.payload;
      const existing = draftState.links[link.patient_user_id] ?? [];
      const next = existing.filter((l) => l.emr_adapter_id !== link.emr_adapter_id);
      next.push(link);
      draftState.links[link.patient_user_id] = next;
    },
  },
});

export const { setEmrLinksAction, upsertEmrLinkAction } = emrLinkSlice.actions;

export default emrLinkSlice;
